<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="33"
		height="34"
		viewBox="0 0 33 34"
		fill="none"
		class="multipleMRN"
	>
		<path
			d="M13.4167 12.4091H5.75C5.24167 12.4091 4.75416 12.6111 4.39471 12.9705C4.03527 13.3299 3.83334 13.8175 3.83334 14.3258V29.6591C3.83334 30.1674 4.03527 30.655 4.39471 31.0144C4.75416 31.3739 5.24167 31.5758 5.75 31.5758H17.25C17.7583 31.5758 18.2458 31.3739 18.6053 31.0144C18.9647 30.655 19.1667 30.1674 19.1667 29.6591V18.1591L13.4167 12.4091Z"
			stroke="#DA4423"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.4167 12.4091V18.1591H19.1667"
			stroke="#DA4423"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.3333 22.9507H7.66666"
			stroke="#DA4423"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.3333 26.7841H7.66666"
			stroke="#DA4423"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<rect
			width="23"
			height="23"
			transform="translate(10 1.49243)"
			fill="white"
		/>
		<path
			d="M23.4167 3.40912H15.75C15.2417 3.40912 14.7542 3.61105 14.3947 3.9705C14.0353 4.32994 13.8333 4.81745 13.8333 5.32579V20.6591C13.8333 21.1674 14.0353 21.655 14.3947 22.0144C14.7542 22.3739 15.2417 22.5758 15.75 22.5758H27.25C27.7583 22.5758 28.2458 22.3739 28.6053 22.0144C28.9647 21.655 29.1667 21.1674 29.1667 20.6591V9.15912L23.4167 3.40912Z"
			stroke="#805AD5"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M23.4167 3.40912V9.15912H29.1667"
			stroke="#805AD5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M25.3333 13.9507H17.6667"
			stroke="#805AD5"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M25.3333 17.7841H17.6667"
			stroke="#805AD5"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'MultipleEpisodeCustomSVGIcon',
}
</script>

<style scoped>
/* Add any necessary styles here */
</style>
